import routeConstant from "../lib/constants/routeConstant";
import CartPage from "../pages/CartPage/CartPage";
import CreatePasswordPage from "../pages/CreatePasswordPage/CreatePasswordPage";
import DeployTokenPage from "../pages/DeployTokenPage/DeployTokenPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage/ForgotPasswordPage";
import LandingPage from "../pages/LandingPage/LandingPage";
import LiveGamePage from "../pages/LiveGamePage/LiveGamePage";
import LoginPage from "../pages/LoginPage/LoginPage";
import MyAccountPage from "../pages/MyAccountPage/MyAccountPage";
import MyCollectibles from "../pages/MyCollectibles/MyCollectibles";
import MyContactInfoPage from "../pages/MyContactInfo/MyContactInfoPage";
import MyPurchaseHistory from "../pages/MyPurchaseHistory/MyPurchaseHistory";
import CookiesPage from "../pages/Others/CookiesPage/CookiesPage";
import PrivacyPage from "../pages/Others/PrivacyPage/PrivacyPage";
import TermsAndConditionsPage from "../pages/Others/TermsAndConditionsPage/TermsAndConditionsPage";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import PaymentPage from "../pages/PaymentPage/PaymentPage";
import ResetPasswordPage from "../pages/ResetPasswordPage/ResetPasswordPage";
// import ScorerPage from "../pages/ScorerPage/ScorerPage";
import SelectSportPage from "../pages/SelectSportPage/SelectSportPage";
import SignUpPage from "../pages/SignUpPage/SignUpPage";
import SportPage from "../pages/SportPage/SportPage";
import VerifyOtpPage from "../pages/VerifyOtp/VerifyOtpPage";

const UNAUTHENTICATED_ROUTES = [
    { path: routeConstant.LOGIN_PAGE, element: <LoginPage /> },
    { path: routeConstant.SIGNUP_PAGE, element: <SignUpPage /> },
    { path: routeConstant.VERIFY_OTP_PAGE, element: <VerifyOtpPage /> },
    { path: routeConstant.CREATE_PASSWORD_PAGE, element: <CreatePasswordPage /> },
    { path: routeConstant.RESET_PASSWORD_PAGE, element: <ResetPasswordPage /> },
    { path: routeConstant.FORGOT_PASSWORD_PAGE, element: <ForgotPasswordPage /> },
]

const AUTHENTICATED_ROUTES = [
    { path: routeConstant.SELECT_SPORT_PAGE, element: <SelectSportPage /> },
    { path: routeConstant.MY_ACCOUNT_PAGE, element: <MyAccountPage /> },
    { path: routeConstant.CART_PAGE, element: <CartPage /> },
    { path: routeConstant.PAYMENT_PAGE, element: <PaymentPage /> },
    { path: routeConstant.DEPLOY_TOKEN_PAGE, element: <DeployTokenPage /> },

    //  Profile-Routes
    { path: routeConstant.MY_CONTACT, element: <MyContactInfoPage /> },
    { path: routeConstant.MY_PURCHASE, element: <MyPurchaseHistory /> },
    { path: routeConstant.MY_COLLECTIBLES, element: <MyCollectibles /> },

    // Sport-Page
    { path: `${routeConstant.SPORT_PAGE}/:sportsSeasonId`, element: <SportPage /> },

    // // Score Game
    // { path: `${routeConstant.SCORE_GAME_PAGE}/:sportsSeasonId/:gameId`, element: <ScorerPage /> },
    { path: `${routeConstant.LIVE_GAME_PAGE}/:gameId`, element: <LiveGamePage /> },
]

const GLOBAL_ROUTES = [
    { path: routeConstant.DEFAULT_PAGE, element: <LandingPage /> },
    { path: routeConstant.TERMS, element: <TermsAndConditionsPage /> },
    { path: routeConstant.PRIVACY, element: <PrivacyPage /> },
    { path: routeConstant.COOKIES, element: <CookiesPage /> },

    // Make it Last Only (*)
    // Fallback Route
    { path: routeConstant.PAGE_NOT_FOUND, element: <PageNotFound /> },
]

export { UNAUTHENTICATED_ROUTES, AUTHENTICATED_ROUTES, GLOBAL_ROUTES };